// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__21skm","bigColWidth":"Table_bigColWidth__LMqBf","biggerColWidth":"Table_biggerColWidth__1CGvl","row":"Table_row__1yAFG","col":"Table_col__2C4W6"};